<svg width="100%"  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="15" transform="rotate(-90 16 16)" fill="white" stroke="#fff" stroke-width="2"/>
<path d="M13 24L21 16L13 8" stroke="#004099" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
